<div class="table-header-actions">
  <div class="table-header-actions__search">
    <ng-content select="app-table-search-bar"></ng-content>
  </div>
  <div class="table-header-actions__content">
    <ng-content></ng-content>
  </div>
  <div class="table-header-actions__tools">
    @if (showColumnPicker) {
      <button
        type="button"
        nz-button
        nzType="text"
        class="icon-btn"
        nz-dropdown
        [nzDropdownMenu]="columnMenu"
        nzTrigger="click"
        [nzClickHide]="false"
        nzOverlayClassName="col-layout-picker-overlay"
        nz-tooltip
        nzTooltipTitle="Spalten ein- und ausblenden"
        aria-label="Spalten ein- und ausblenden"
        (nzVisibleChange)="onColumnMenuVisible($event)"
      >
        <i nz-icon nzType="table" nzTheme="outline"></i>
      </button>
      <nz-dropdown-menu #columnMenu="nzDropdownMenu">
        <ul nz-menu class="col-layout-picker">
          @for (col of columnOptions; track col.key) {
            <li nz-menu-item (click)="$event.preventDefault()">
              <label
                nz-checkbox
                [nzDisabled]="col.locked || (col.visible && lastHideableVisible)"
                [ngModel]="col.visible"
                (ngModelChange)="toggleColumn(col.key, $event)"
              >
                {{ col.label }}
              </label>
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    }
    @if (showColumnReset) {
      <app-icon-button
        icon="undo"
        ariaLabel="Spalten zurücksetzen"
        (pressed)="resetColumns()"
      ></app-icon-button>
    }
    @if (withClearCache) {
      <app-icon-button
        icon="clear"
        ariaLabel="Cache leeren / Sync"
        (pressed)="clearCache.emit()"
      ></app-icon-button>
    }
    @if (withExportOption) {
      <app-icon-button
        icon="export"
        ariaLabel="Exportieren"
        (pressed)="exportBtnClicked.emit()"
      ></app-icon-button>
    }
    <app-icon-button
      icon="sync"
      ariaLabel="Neu laden"
      [loading]="loading"
      (pressed)="reload.emit()"
    ></app-icon-button>
  </div>
</div>
